//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, {
  useState,
  useContext,
  useCallback,
  useEffect,
  Fragment,
} from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from 'react-i18next';

// custom pages
import Context from "context/context";
import "assets/css/custom.css";
import useForm from "helpers/useForm";
import { loginValidate } from "helpers/validateRules/auth";
import auth from "apis/auth/auth";
import LoginParent from "components/AuthPages/LoginParent";
import "../../assets/css/login.css";
import { loginStyles } from "./styles";
import Loader from "components/Loader/Loader";
import access from "config/access";

// material-ui
import {
  withStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import Tooltip from "@material-ui/core/Tooltip";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import MenuItem from "@material-ui/core/MenuItem";

// material-ui icons
import VisibilityOffOutlinedIcon from '@material-ui/icons/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

// custom TextField
const CssTextField = withStyles({
  root: {
    '& label.Mui-focused': {
      background: 'transparent',
    },
    '& .MuiFormLabel-root': {
      background: 'transparent',
    },
    '& .MuiInputBase-input': {
      background: 'transparent',
    },
    '& .MuiInput-underline:before': {
      borderBottomColor: '#fff!important',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#fff!important',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#fff',
      },
      '&:hover fieldset': {
        borderColor: '#fff',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#fff',
      },
    },
  },
})(TextField);

const GlobalCss = withStyles({
  '@global': {
    '.MuiSelect-icon': {
      color: '#fff',
    },
  },
})(() => null);

const formLabelsTheme = createMuiTheme({
  overrides: {
    MuiFormLabel: {
      asterisk: {
        color: '#db3131',
        '&$error': {
          color: '#db3131',
        },
      },
    },
  },
  palette: {
    primary: {
      main: '#000000',
    },
  },
});

const toastCss = {
  position: 'top-right',
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: false,
  draggable: true,
  progress: undefined,
};

const initialValues = {
  email: "",
  password: "",
  org: "",
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

const org = [
  {
    value: "Henry Schein Dental",
    label: "Henry Schein Dental",
  },
  {
    value: "Henry Schein Canada",
    label: "Henry Schein Canada",
  },
];

export default function Login() {
  const { state, dispatch } = useContext(Context);
  const [open, setOpen] = React.useState(false);
  const [initialLoad, setInitialLoad] = useState(false);
  const { t, i18n } = useTranslation();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    // Check if GTM is already initialized
    const isGTMInitialized =
      window.dataLayer && window.dataLayer.length > 0 ||
      window.google_tag_manager && Object.keys(window.google_tag_manager).length > 0;
  
    if (isGTMInitialized) {
      console.log("GTM detected → Disconnecting...");
  
      // 1️⃣ Clear dataLayer
      window.dataLayer = [];
  
      // 2️⃣ Reset GTM internal object
      window.google_tag_manager = {};
  
      // 3️⃣ Remove GTM script tags from DOM
      document
        .querySelectorAll('script[src*="gtm"], iframe[src*="gtm"]')
        .forEach((el) => el.remove());
    }
  }, []);
  
  const history = useHistory();
  const { login, isLoggedIn } = auth();

  const classes = loginStyles();

  const [states, setstates] = useState({
    showPassword: false,
    tooltipName: '',
    tooltipCondition: false,
    disableButton: false,
  });

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  // handling inputs
  const { values, errors, handleSubmit, handleChange } = useForm(
    initialValues,
    handlelogin,
    loginValidate
  );

  // login api func
  async function handlelogin() {
    try {
      dispatch({ type: 'SET_LOADING', payload: true });
      let res = await login(values);
      if (res && res.type == 'success') {
        i18n.changeLanguage(res?.user?.language_code);
        dispatch({ type: 'SET_USERINFO', payload: res.user });
        dispatch({ type: 'SET_LANGUAGE', payload: res.language });
        dispatch({ type: 'SET_ISLOGGEDIN', payload: true });
        dispatch({ type: 'SET_REDIRECTION_LINKS', payload: res.linksObj });
        if(res?.passwordExpireNotification){
          toast.error(res?.passwordExpireNotification,
            {
              autoClose: 5000,
              },
            {toastId:"login-password-notification"}
          );
        }
        if(res?.customerAccount){
          dispatch({ type: "SET_ACA", payload: res?.customerAccount });
        }
        if (res?.loyaltyAccount) {
          dispatch({ type: 'SET_ALA', payload: res?.loyaltyAccount });
          dispatch({ type: 'SET_LOADING', payload: false });
          return history.push('/dashboard/mydashboard');
        }
        dispatch({ type: 'SET_LOADING', payload: false });
        return history.push('/dashboard/loyalty');
      }
      dispatch({ type: 'SET_LOADING', payload: false });
      toast.error(
        res && res.message ? (
          res.message
        ) : (
          <React.Fragment>
            <div>Password Incorrect</div>
            <div>{res.handleResponse.message + ' ' + res.reduceValue}</div>
          </React.Fragment>
        ),
        toastCss,
        {toastId:"login-error"}
      );
      setStates({ disableButton: false });
    } catch (e) {
      toast.error('something went wrong', toastCss);
    }
  }

  useEffect(() => {
    handleIsLoggedIn();
  }, []);

  async function handleIsLoggedIn() {
    try {
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await isLoggedIn();
      if (res && res?.user && res?.user?.role_id !== null) {
        i18n.changeLanguage(res?.user?.language_code);
        dispatch({ type: "SET_USERINFO", payload: res.user });
        dispatch({ type: 'SET_LANGUAGE', payload: res.language });
        dispatch({ type: "SET_ISLOGGEDIN", payload: true });
        if (res?.loyaltyAccount) {
          dispatch({ type: 'SET_ALA', payload: res?.loyaltyAccount });
          dispatch({ type: 'SET_LOADING', payload: false });
          return history.push('/dashboard/mydashboard');
        }
        dispatch({ type: "SET_LOADING", payload: false });
        history.push("/dashboard/loyalty");
      }
      setInitialLoad(true);
      dispatch({ type: "SET_LOADING", payload: false });
      return;
    } catch (err) {
      console.log({ err });
    }
  }

  useEffect(() => {
    i18n.changeLanguage("en");
  }, [])

  const clearError = (key) => {
    if (errors?.[key]) {
      delete errors[key];
    }
    return;
  };

  return initialLoad ? (
    <Fragment>
      <LoginParent>
        <GlobalCss />
        <div className={classes.loginText}>Log In</div>
        <div className={classes.inputMainDiv}>
          <ThemeProvider theme={formLabelsTheme}>
            <div className={classes.emailInputDiv}>
              <div xs={{ span: 24 }} sm={{ span: 24 }} lg={{ span: 24 }}>
                <CssTextField
                  id="emailId"
                  label="Email ID"
                  type={"email"}
                  autoComplete="off"
                  onfocus="this.removeAttribute('readonly')"
                  fullWidth={true}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Tooltip
                          arrow
                          placement="top-start"
                          disableFocusListener
                          disableHoverListener
                          disableTouchListener
                          title="Please call Thrive Rewards Customer Service at 1-800-888-6684 (8 AM-8 PM EST Monday-Friday) to retrieve your Email ID"
                          open={
                            states.tooltipName === "leadTime" &&
                              states.tooltipCondition
                              ? true
                              : false
                          }
                        >
                          <IconButton
                            onClick={() =>
                              setStates({
                                tooltipName: "leadTime",
                                tooltipCondition: !states.tooltipCondition,
                              })
                            }
                            className={classes.emailInputIconBtn}
                          >
                            <InfoOutlinedIcon
                              className={classes.emailInputIcon}
                            />
                          </IconButton>
                        </Tooltip>
                      </InputAdornment>
                    ),
                  }}
                  value={values.email}
                  onChange={(e) => {
                    handleChange({ name: "email", value: e.target.value });
                    clearError("email");
                  }}
                />
              </div>
              {errors.email && <span className="error">{errors.email}</span>}
            </div>
            <br />
            <div className={classes.passwordInputDiv}>
              <div xs={{ span: 24 }} sm={{ span: 24 }} lg={{ span: 24 }}>
                <CssTextField
                  id="pd"
                  label="Password"
                  type={states.showPassword ? "text" : "password"}
                  autoComplete="new-password"
                  onfocus="this.removeAttribute('readonly')"
                  fullWidth={true}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          // onClick={() => {
                          //   setStates({ showPassword: !states.showPassword });
                          // }}
                          onMouseUp={() => {
                            setStates({ showPassword: false });
                          }}
                          onMouseDown={() => {
                            setStates({ showPassword: true });
                          }}
                          onMouseLeave={() => {
                            setStates({ showPassword: false });
                          }}
                          edge="end"
                        >
                          {states.showPassword ? (
                            <VisibilityOutlinedIcon
                              className={classes.passwordInputIconBtn}
                            />
                          ) : (
                            <VisibilityOffOutlinedIcon
                              className={classes.passwordInputIcon}
                            />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  value={values.password}
                  onChange={(e) => {
                    handleChange({ name: "password", value: e.target.value });
                    clearError("password");
                  }}
                  onPaste={(e) => {
                    e.preventDefault();
                    return false;
                  }}
                />
              </div>
              {errors.password && (
                <span className="error">{errors.password}</span>
              )}
            </div>
            <br />
            <div className={classes.passwordInputDiv}>
              <div xs={{ span: 24 }} sm={{ span: 24 }} lg={{ span: 24 }}>
                <CssTextField
                  id={"organization"}
                  label={"Organization"}
                  select
                  fullWidth
                  type={"text"}
                  value={values.org}
                  onChange={(e) => {
                    handleChange({ name: "org", value: e.target.value });
                    clearError("org");
                  }}
                >
                  {org.map((o, i) => (
                    <MenuItem value={o.value} key={i}>
                      {o.label}
                    </MenuItem>
                  ))}
                </CssTextField>
              </div>
              {errors.org && <span className="error">{errors.org}</span>}
            </div>
            <div>
              <div
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                lg={{ span: 24 }}
                className={classes.forgotPasswordText}
                onClick={() => {
                  history.push("/forgotpassword");
                }}
              >
                Create, Reset or Forgot Password
              </div>
            </div>
          </ThemeProvider>
        </div>
        <div className={classes.loginBtnDiv}>
          <Button
            variant="contained"
            className={classes.loginBtn}
            onClick={() => {
              handleSubmit();
              setStates({ disableButton: true });
            }}
          >
            <Loader Loading={state.loading} color={"#fff"}>
              {" "}
              Log In
            </Loader>
          </Button>
        </div>
        <div className={classes.newAccountText}>
          <span
            onClick={handleClickOpen}
            style={{ textDecoration: "underline" }}
          >
            Don't have an account?
          </span>
        </div>
        <Dialog
          open={open}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle>
            <div
              style={{
                position: "absolute",
                top: "1%",
                right: "2%",
                cursor: "pointer",
                color: "red",
                fontSize: 26,
              }}
              onClick={handleClose}
            >
              x
            </div>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              <div style={{ fontSize: 27, color: "red", marginBottom: -20 }}>
                *
              </div>
              <div style={{ fontSize: 16, color: "#000" }}>
                Please send an email to{" "}
                <span style={{ fontWeight: 900, textDecoration: "underline" }}>
                  thriverewards@henryschein.com
                </span>{" "}
                requesting the program admin access
              </div>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      </LoginParent>
    </Fragment>
  ) : (
    <div
      style={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Loader Loading={state.loading} color={"#fff"}></Loader>
    </div>
  );
}
